import type { Column } from '#client/components/ui/DataTable';
import { ResourceListPage } from '#client/components/ui/ResourceListPage';
import type { Panel } from '#shared/types';
import { RESOURCE } from '#client/lib/routes';

const columns: Column<Panel>[] = [
  { key: 'name', header: 'Name', render: (row) => <strong>{row.name}</strong> },
  { key: 'code', header: 'Code', render: (row) => row.code, width: '140px' },
  { key: 'owner_name', header: 'Owner', render: (row) => row.owner_name },
  { key: 'phone_number', header: 'Phone', render: (row) => row.phone_number },
  {
    key: 'discount_percentage',
    header: 'Discount',
    render: (row) => `${row.discount_percentage}%`,
    align: 'end',
    width: '110px',
  },
];

export function PanelListPage() {
  return (
    <ResourceListPage<Panel>
      title="Panels"
      subtitle="Referring organisations with negotiated discounts"
      path={RESOURCE.panels}
      columns={columns}
      noun="panel"
      nounPlural="panels"
      searchPlaceholder="Search by name, code or owner"
      rowLabel={(row) => row.name}
      createCapability="panel.create"
      editCapability="panel.edit"
      deleteCapability="panel.delete"
    />
  );
}
